import { MessageSquare, ShieldAlert, CalendarCheck } from "lucide-react";

const bullets = [
  {
    icon: MessageSquare,
    text: "Chat web + WhatsApp",
  },
  {
    icon: ShieldAlert,
    text: "Orientación ante posibles urgencias (no diagnóstico)",
  },
  {
    icon: CalendarCheck,
    text: "Solicitud de cita (recogida de datos para confirmación)",
  },
];

export const DemoIncludesSection = () => {
  return (
    <section
      data-testid="demo-includes-section"
      className="py-16 md:py-20"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="bg-secondary/30 rounded-2xl p-8 md:p-10 border border-primary/5">
          <h3
            data-testid="demo-includes-title"
            className="text-xl md:text-2xl font-bold text-foreground tracking-tight mb-3 text-center"
          >
            Qué incluye esta demo
          </h3>
          <p className="text-muted-foreground text-center leading-relaxed mb-8 max-w-xl mx-auto">
            Esta demo muestra cómo el asistente atiende dudas frecuentes,
            orienta posibles urgencias y registra solicitudes de cita.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
            {bullets.map((item, index) => {
              const Icon = item.icon;
              return (
                <div
                  key={index}
                  data-testid={`demo-includes-bullet-${index}`}
                  className="flex items-center gap-3 bg-white rounded-xl px-5 py-3.5 border border-border/40 shadow-[0_2px_8px_-2px_rgba(0,0,0,0.04)]"
                >
                  <Icon className="w-5 h-5 text-primary shrink-0" strokeWidth={1.5} />
                  <span className="text-sm font-medium text-foreground">{item.text}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
